import { Breadcrumb, Card, Col, EventHandler, InputField, Label, PrimaryButton, Row, SofturaTable } from "client/CommonComponents"
import './AcquisitionCodeMaintenanceListing.scss';
import CancelConfirmationPopup from "client/CommonComponents/DialogBox/CancelConfirmationPopup";
import permissions, { isAuthorized } from "client/utils/Permissions";

const AcquisitionListing = ({
    acquisitionListingColumns,
    breadcrumlist,
    handleClickBack,
    createNewCodeList,
    handleOnChange,
    acquisitionValues,
    handleClickAdd,
    Popupcontent,
    hideDialog,
    fetchAction,
    serverTotal,
    pagesCount,
    setFilters,
    showGrid }: any) => {
    return (
        <>
            <div className='breadCrumbBlock'>
                <EventHandler onEvent={handleClickBack} data-attribute="AcquisitionCodeMaintenanceListing_Default_EventHandler">
                    <div className='backButton mb-sm-2 mb-3'>
                        <span className="fa fa-chevron-left"></span>
                        Back
                    </div>
                </EventHandler>               
                <div className='breadcrumbList'>
                    <Breadcrumb items={breadcrumlist} maxDisplayedItems="5"  data-attribute="AcquisitionCodeMaintenanceListing_Default_Breadcrumb" />
                </div>
            </div>
            <Card data-attribute="AcquisitionCodeMaintenanceListing_Default_Card">
                <div className='create-new-order-container admin-tab'>
                    <div className='grid-block pt-3 pb-0'>
                        <div className='mb-3 top-section clearfix'>
                            <p className='pull-left blueLabel mt-2'>ACQUISTION CODE MAINTENANCE</p>
                        </div>
                        <div className='bottom-section'>
                            <Row>
                                <Col xs={12} sm={12} lg={5} className={'mb-3'}>
                                    <p className="blueLabel mb-3">List of Existing Codes</p>
                                    <div
                                        className={
                                            createNewCodeList?.length !== 0
                                                ? "softura-table "
                                                : "softura-table paginationNav"
                                        }
                                    >
                                        {showGrid &&
                                            <SofturaTable
                                                data={createNewCodeList?.data ?? []}
                                                columns={acquisitionListingColumns}
                                                sort={true}
                                                defaultPageSize={10}
                                                pageSizes={[10, 20, 50]}
                                                globalSearch={false}
                                                filter={true}
                                                serverTotal={serverTotal}
                                                fetchAction={fetchAction}
                                                isServerSide={true}
                                                pagesCount={pagesCount}
                                                getFilterValue={setFilters}
                                             data-attribute="AcquisitionCodeMaintenanceListing_Default_Grid" />
                                        }
                                    </div>
                                </Col>
                                <Col xs={12} sm={12} lg={7} className={'mb-3'}>
                                    <p className="blueLabel mb-3">Add New Code</p>
                                    <div className="add-new-code-container">
                                        <Row>
                                            <Col xs={12} sm={12} lg={6} className={'mb-3'}>
                                                <Label required data-attribute="AcquisitionCodeMaintenanceListing_Default_Label">Code</Label>
                                                <InputField
                                                    placeholder="Enter Text"
                                                    value={acquisitionValues?.acquisitionCode ?? ''}
                                                    className={acquisitionValues?.acquisitionCodeError?.length ? 'controlValidation' : ""}
                                                    name='acquisitionCode'
                                                    onChange={(e: any) => { handleOnChange(e) }}  data-attribute="AcquisitionCodeMaintenanceListing_acquisitionCode_Input" />
                                                {acquisitionValues?.acquisitionCodeError?.length ? <p className='validMessage'>{acquisitionValues?.acquisitionCodeError}</p> : ""}
                                            </Col>
                                            <Col xs={12} sm={12} lg={6} className={'mb-3'}>
                                                <Label required data-attribute="AcquisitionCodeMaintenanceListing_Default_Label_2">Description</Label>
                                                <InputField
                                                    placeholder="Enter Text"
                                                    name='acquisitionDescription'
                                                    value={acquisitionValues?.acquisitionDescription}
                                                    className={acquisitionValues?.acquisitionDescriptionError?.length ? 'controlValidation' : ""}
                                                    onChange={(e: any) => { handleOnChange(e) }}
                                                 data-attribute="AcquisitionCodeMaintenanceListing_acquisitionDescription_Input" />
                                                {acquisitionValues?.acquisitionDescriptionError?.length ? <p className='validMessage'>{acquisitionValues?.acquisitionDescriptionError}</p> : ""}
                                            </Col>
                                            <div>
                                                <PrimaryButton className={'pull-right'} text="Add" onClick={handleClickAdd} disabled={!isAuthorized(permissions.Create_Edit_Admin)} data-attribute="AcquisitionCodeMaintenanceListing_Default_Button" />
                                            </div>
                                        </Row>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </div>
            </Card>
            {Popupcontent.isDialogVisible ?
                <CancelConfirmationPopup
                    hideDialog={!Popupcontent.isDialogVisible}
                    onDismiss={hideDialog}
                    Popupcontent={Popupcontent}
                    popupOutlinebtnOnclick={() => Popupcontent.popupOutlinebtnOnclick()}
                    popupPrimarybtnOnclick={() => Popupcontent.popupPrimarybtnOnclick()}
                />
                : ""}
        </>
    )
}

export default AcquisitionListing